import React, { FC } from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import {
  Commentary,
  TypeLabel,
  UserCommentary,
  Format,
} from '../commentary.types';
import { RenderHighlightedParts } from '../../components/highlight/RenderHighlightedParts';
import styles from './commentary_header.module.scss';
import './commentary_item_header.scss';
import { Highlight } from '../../components/highlight/Highlight';
import { MaterialIcon } from '../../components/material-icon/MaterialIcon';

type Props = {
  commentary: Commentary | UserCommentary;
  isDoctrineLink?: boolean;
  small: boolean;
};

export const CommentaryHeader: FC<Props> = ({
  commentary,
  isDoctrineLink = false,
  small,
}) => (
  <span className={styles.container}>
    <span
      className={classNames(
        commentary.typeLabel === TypeLabel.PAPER
          ? 'commentary-item-header__title--nolink'
          : 'commentary-item-header__title--link',
        small && styles.titleSmall,
      )}
    >
      <RenderHighlightedParts
        config={{
          preTag: 'highlight_start',
          postTag: 'highlight_stop',
        }}
        renderHighlightedParts={renderCallback}
      >
        {commentary.title}
      </RenderHighlightedParts>
    </span>
    {!isDoctrineLink && (
      <span className={styles.info}>
        {commentary.typeLabel === TypeLabel.HYBRID && (
          <span className={styles.text}>
            <FormattedMessage id="commentary/card/CommentaryHeader.tsx/1" />
          </span>
        )}
        <MaterialIcon
          className={classNames(
            'commentary-item-header__icon',
            small && styles.iconSmall,
          )}
          name={getIconClassname(commentary)}
        />
      </span>
    )}
  </span>
);

function getIconClassname(commentary: Commentary | UserCommentary) {
  if (commentary.typeLabel === TypeLabel.PAPER) {
    return 'lock';
  }
  if (commentary.typeLabel === TypeLabel.HYBRID) {
    return 'lock_open';
  }
  if (
    commentary.format === Format.HTML ||
    commentary.typeLabel === TypeLabel.USER_GENERATED
  ) {
    return 'launch';
  }
  return 'picture_as_pdf';
}

function renderCallback(
  {
    value,
    highlighted,
  }: {
    value: string;
    highlighted: boolean;
  },
  index: number,
) {
  if (highlighted) return <Highlight key={index}>{value}</Highlight>;
  return value;
}
